<template>
  <div>
    <div class="relative mb-3 pb-56%">
      <div class="absolute inset-0">
        <VenueMap :venue="venue" class="size-full" />
      </div>
    </div>
    <a :href="`https://google.com/maps/?q=${venue.latitude},${venue.longitude}`" target="_blank" rel="noopener noreferrer" class="mb-2 inline-block text-sm text-body underline hover:text-black">View larger map</a>
    <div v-if="venue.venue_type_id === 1">
      <NuxtLink :to="`/${venue.path}/comparisons`" class="mb-2 inline-block text-sm text-body underline hover:text-black">
        Compare with nearby hotels
      </NuxtLink>
    </div>
    <p v-if="venue.telephone" class="mb-2 text-sm text-body">
      {{ venue.telephone }}
    </p>
    <p class="mb-2 text-sm text-body">
      {{ venue.address }}
    </p>
    <p v-if="venue.website" class="mb-2 text-sm text-body underline">
      <a :href="venue.website" class="hover:text-black" target="_blank" rel="noopener noreferrer">Website</a>
    </p>
    <p v-if="venue.star_rating" class="mb-2 text-sm text-body">
      {{ venue.star_rating }} stars
    </p>
    <div v-if="venue.opening_hours">
      <OpenningHours :venue="venue" />
    </div>
  </div>
</template>

<script>
import VenueMap from '~/components/venue/VenueMap'
import OpenningHours from '~/components/venue/OpenningHours'

export default {
  components: { OpenningHours, VenueMap },

  props: {
    venue: { type: Object, required: true },
  },
}
</script>
